import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import styles from './FixedBottomBox.module.scss';

const cx = classNames.bind(styles);

const FixedBottomBox = forwardRef(({ children, bottomGutter = 0, hasGradatedBackground = false, wrapClassName = '', botClassName = '', customStyles = {} }, ref) => (
	<div
		ref={ref}
		className={cx('fix_wrap', wrapClassName, { gradation: hasGradatedBackground })}
		style={{ height: bottomGutter }}
	>
		<div
			className={cx('fix_bottom', botClassName)}
			style={{ ...customStyles }}
		>
			{children}
		</div>
	</div>
));

FixedBottomBox.displayName = 'FixedBottomBox';
export default FixedBottomBox;
